<template>
  <span :style="{ color: color }"> {{ (character) ? character : '|' }} </span>
</template>

<script>
export default {
  name: "Separator",
  props: ['color', 'character']
}
</script>

<style scoped>

</style>
